// Librerías
import React, { useState } from "react";
import { Link } from "react-router-dom";
// Recursos
import "../../assets/styles/Footer/_footer.sass";
import facebook from "../../assets/static/Icons/facebook.svg";
import instagram from "../../assets/static/Icons/instagram.svg";
import BLACK_LOGO_ALOHAR from "../../assets/static/Navbar/BLACK_LOGO_ALOHAR.svg";
import ArrowLeft from "../../assets/components-icons/ArrowLeft";
import "../../assets/styles/Buttons/btn.sass";
import useCurrentLanguaje from "../../services/currentlenguaje";
import jsonFooter from "../../components/Footer/jsonFooter.json";

const Footer = () => {
  const [expandedSections, setExpandedSections] = useState({
    alohar: false,
    support: false,
    destinos: false,
    legal: false
  });

  const toggleSection = (section) => {
    setExpandedSections(prev => ({
      ...prev,
      [section]: !prev[section]
    }));
  };

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  const { handleFilterLang } = useCurrentLanguaje();

  return (
    <div className="Footer">
      <div className="Footer__container">
        {/* Logo - Solo visible en desktop */}
        <div className="Footer__logo">
          <Link to="/" rel="noopener noreferrer" onClick={scrollToTop}>
            <img src={BLACK_LOGO_ALOHAR} alt="Alohar TM" />
          </Link>
        </div>
        
        {/* Botón scroll to top en móvil */}
        <div className="Footer__scroll-button">
          <button
            aria-label="Scroll to head"
            onClick={scrollToTop}
            className="Footer__scroll-btn"
          >
            <ArrowLeft color={"#38d1da"} className={" rotate-90"} />
          </button>
        </div>

        {/* COLUMNA 1: Quiero ser Alohador */}
        <div className="Footer__column Footer__column--alohar">
          {/* Header collapsible para móvil */}
          <div 
            className="Footer__collapsible-header"
            onClick={() => toggleSection('alohar')}
          >
            <h3 className="Footer__column-title">{handleFilterLang(jsonFooter).quieroSerAlohador}</h3>
            <ArrowLeft 
              className={`Footer__collapsible-arrow ${expandedSections.alohar ? 'expanded' : ''}`} 
              size={16} 
            />
          </div>
          
          {/* Contenido - Siempre visible en desktop, collapsible en móvil */}
          <div className={`Footer__collapsible-content ${expandedSections.alohar ? 'expanded' : ''}`}>
            {/* Logo Alohar Negro */}
            <div className="Footer__alohar-logo">
              <img src={BLACK_LOGO_ALOHAR} alt="Alohar" className="Footer__alohar-logo-img" />
            </div>
            
            <Link
              rel="noopener noreferrer"
              to="/quiero-ser-alohador"
              className="Footer__link"
              onClick={scrollToTop}
            >
              {handleFilterLang(jsonFooter).quieroSerAlohador}
            </Link>
            <p className="Footer__email">alohar.arg@gmail.com</p>

            {/* Redes Sociales */}
            <div className="Footer__social-media">
              <a
                href="https://www.facebook.com/alohar.me"
                target="_blank"
                rel="noopener noreferrer"
                className="Footer__social-link"
              >
                <img
                  className="Footer__social-icon"
                  src={facebook}
                  alt="Facebook de Alohar"
                />
              </a>
              <a
                href="https://instagram.com/alohar.me/"
                target="_blank"
                rel="noopener noreferrer"
                className="Footer__social-link"
              >
                <img
                  className="Footer__social-icon"
                  src={instagram}
                  alt="Instagram de Alohar"
                />
              </a>
            </div>
          </div>
        </div>

        {/* COLUMNA 2: Atención al Cliente */}
        <div className="Footer__column Footer__column--support">
          {/* Header collapsible para móvil */}
          <div 
            className="Footer__collapsible-header"
            onClick={() => toggleSection('support')}
          >
            <h3 className="Footer__column-title">Atención al Cliente</h3>
            <ArrowLeft 
              className={`Footer__collapsible-arrow ${expandedSections.support ? 'expanded' : ''}`} 
              size={16} 
            />
          </div>

          {/* Contenido - Siempre visible en desktop, collapsible en móvil */}
          <div className={`Footer__collapsible-content ${expandedSections.support ? 'expanded' : ''}`}>
            <div className="Footer__support-section">
              <h4 className="Footer__support-title">{handleFilterLang(jsonFooter).atencionAlohadores}</h4>
              <a
                href="mailto:alohar.arg@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="Footer__phone-link"
              >
                alohar.arg@gmail.com
              </a>
            </div>
            
            <div className="Footer__support-section">
              <h4 className="Footer__support-title">{handleFilterLang(jsonFooter).atencionHuespedes}</h4>
              <a
                href="mailto:alohar.arg@gmail.com"
                target="_blank"
                rel="noopener noreferrer"
                className="Footer__phone-link"
              >
                alohar.arg@gmail.com
              </a>
            </div>

            <Link 
              rel="noopener noreferrer" 
              className="Footer__link" 
              to={"/ayuda"}
              onClick={scrollToTop}
            >
              FAQ
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to={"/contacto"} onClick={scrollToTop}>
              Contacto
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to={"/quienes-somos"} onClick={scrollToTop}>
              Quiénes somos
            </Link>
          </div>
        </div>

        {/* COLUMNA 3: Destinos */}
        <div className="Footer__column Footer__column--destinos">
          {/* Header collapsible para móvil */}
          <div
            className="Footer__collapsible-header"
            onClick={() => toggleSection('destinos')}
          >
            <h3 className="Footer__column-title">Destinos</h3>
            <ArrowLeft
              className={`Footer__collapsible-arrow ${expandedSections.destinos ? 'expanded' : ''}`}
              size={16}
            />
          </div>

          {/* Contenido - Siempre visible en desktop, collapsible en móvil */}
          <div className={`Footer__collapsible-content ${expandedSections.destinos ? 'expanded' : ''}`}>
            <Link rel="noopener noreferrer" className="Footer__link" to="/destinos/mar-del-plata" onClick={scrollToTop}>
              Mar del Plata
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to="/destinos/bariloche" onClick={scrollToTop}>
              Bariloche
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to="/destinos/iguazu" onClick={scrollToTop}>
              Iguazú
            </Link>
          </div>
        </div>

        {/* COLUMNA 4: Términos y Condiciones */}
        <div className="Footer__column Footer__column--legal">
          {/* Header collapsible para móvil */}
          <div 
            className="Footer__collapsible-header"
            onClick={() => toggleSection('legal')}
          >
            <h3 className="Footer__column-title">Términos y Condiciones</h3>
            <ArrowLeft 
              className={`Footer__collapsible-arrow ${expandedSections.legal ? 'expanded' : ''}`} 
              size={16} 
            />
          </div>

          {/* Contenido - Siempre visible en desktop, collapsible en móvil */}
          <div className={`Footer__collapsible-content ${expandedSections.legal ? 'expanded' : ''}`}>
            <Link className="Footer__link" rel="noopener noreferrer" to={"/terminos"} onClick={scrollToTop}>
              {handleFilterLang(jsonFooter).termYCondiciones}
            </Link>
            <Link className="Footer__link" rel="noopener noreferrer" to={"/politica-de-privacidad"} onClick={scrollToTop}>
              {handleFilterLang(jsonFooter).politicaPriv}
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to={"/quienes-somos"} onClick={scrollToTop}>
              Quiénes somos
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to={"/contacto"} onClick={scrollToTop}>
              Contacto
            </Link>
            <Link rel="noopener noreferrer" className="Footer__link" to={"/ayuda"} onClick={scrollToTop}>
              FAQ
            </Link>
          </div>
        </div>

        {/* Copyright - Spanning full width */}
        <div className="Footer__copyright">
          <p className="Footer__copyright-text">
            2021-2023, Alohar.me | Buchu SA.<br />
            {handleFilterLang(jsonFooter).copyright} EVT 18665 - Disp. 0602/2023.
          </p>
          <p className="Footer__tourism-text">
            {handleFilterLang(jsonFooter).turismoNacion}
          </p>
        </div>
      </div>
    </div>
  );
};

export default Footer;
